import _PropTypes from 'prop-types';
import * as React from 'react';
import { noop } from '../../utils/util.js';
import { useAccordionContext } from '../AccordionContext/AccordionContext.js';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);

var AccordionItemContext = function AccordionItemContext(props) {
  var children = props.children,
      focused = props.focused,
      _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      _props$onHeaderEvent = props.onHeaderEvent,
      onHeaderEvent = _props$onHeaderEvent === void 0 ? noop : _props$onHeaderEvent;

  var _useAccordionContext = useAccordionContext(),
      accordionId = _useAccordionContext.accordionId,
      openPanels = _useAccordionContext.openPanels;

  var itemId = "".concat(accordionId, "-item-").concat(index);
  var panelId = "panel-".concat(itemId);
  var headerId = "header-".concat(itemId);
  var open = openPanels.includes(index);
  var context = React.useMemo(function () {
    return {
      focused: focused,
      headerId: headerId,
      onHeaderEvent: onHeaderEvent,
      open: open,
      panelId: panelId,
      index: index
    };
  }, [focused, headerId, onHeaderEvent, open, panelId, index]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: children
  });
};

AccordionItemContext.propTypes = {
  "children": _PropTypes.node,
  "focused": _PropTypes.bool,
  "index": _PropTypes.number,
  "onHeaderEvent": _PropTypes.func
};
AccordionItemContext.displayName = "AccordionItemContext";
function useAccordionItemContext() {
  var accordionItemContext = React.useContext(Context);

  if (!accordionItemContext) {
    throw new TypeError("No AccordionItemContext provided");
  }

  return accordionItemContext;
}

export { AccordionItemContext, useAccordionItemContext };
